import './loading-overlay.css';
import { useSelector } from "react-redux";
import { RootState } from "../../../state/store";
import { ILoadingOverlayState } from '../../../state/interfaces/ILoadingOverlayState';

const LoadingOverlay = () => {
  const overlayState: ILoadingOverlayState = useSelector((state: RootState) => state.overlayState);

  return (
    <>
    {
      <div className={`${'overlay-background-container'} ${overlayState.isVisible ? 'd-flex' : 'd-none'}`}>
        <div className='overlay-content-container'>
          <span className="loader">{overlayState.message}</span>
        </div>
      </div>
    }
    </>
  )
}

export default LoadingOverlay;
